export default __webpack_public_path__ + "static/media/Untitled-2.af8b7016.png";